export default {
  operationsAnalyticsPG: {
    role: 'feature:analytics:operations-pg',
    displayName: 'Analytics: Operations (PG)',
    description: 'User can access operations analytics from PG',
    disabled: true
  },
  financialAnalytics: {
    role: 'feature:analytics:financial',
    displayName: 'Analytics: Financial',
    description: 'User can access financial analytics views'
  }
}
